import SectionHeading from "./SectionHeading";
import { plotHighlights } from "@/mocks/movieData";

export default function PlotSection() {
  return (
    <section id="plot" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="lg:col-span-5">
            <SectionHeading
              eyebrow="Story"
              title="剧情梗概与核心看点"
              desc="完整版的价值不只是时长，而是让情绪与因果链更完整。下面从叙事方式、人物张力与观看体验三个角度拆解这部剧的看点。"
            />
            <div className="rounded-xl overflow-hidden border border-background-200 bg-background-50">
              <div className="w-full aspect-[16/10]">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20interior%20scene%20of%20a%20quiet%20family%20living%20room%20at%20dusk%2C%20soft%20amber%20lamp%20light%2C%20deep%20shadows%20across%20the%20sofa%2C%20muted%20terracotta%20and%20brown%20tones%2C%20melancholic%20domestic%20atmosphere%2C%20film%20grain%2C%20emotionally%20charged%20mood&width=1200&height=750&seq=plot-scene-01&orientation=landscape"
                  alt="《嫂子的诱惑》剧情场景氛围示意"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-4 md:p-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  故事以家庭日常为底色，把矛盾藏在细节里。正是这些不显眼的铺垫，让后续的每一次转折都有迹可循。
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
              {plotHighlights.map((item) => (
                <article
                  key={item.title}
                  className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-5 hover:border-primary-300 hover:bg-primary-50/40 transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 text-xl shrink-0">
                      <i className={item.icon} />
                    </span>
                    <h3 className="text-base font-semibold text-foreground-950">{item.title}</h3>
                  </div>
                  <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}